// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NJIt","col":"styles_col__2QYFw"};